import { INVITE_TYPE } from './constants';

const defaultMeta = {
  layout: 'ui-design',
  title: 'Приглашение',
  hideMeta: true,
};

export default [
  {
    path: '/invite/:invite',
    name: 'ui-invite',
    component: () => import('./views/index.vue'),
    meta: defaultMeta,
    props: (route) => ({
      invite: route?.params?.invite,
    }),
    beforeEnter: (to, from, next) => {
      if ([to?.params?.invite].includes(undefined)) {
        next({ name: 'main' });
        return;
      }
      next();
    },
    children: [
      {
        path: INVITE_TYPE.clubMember,
        name: `ui-invite-${INVITE_TYPE.clubMember}`,
        component: () => import('./views/club-member.vue'),
        meta: defaultMeta,
      },
      {
        path: INVITE_TYPE.clubSupervisor,
        name: `ui-invite-${INVITE_TYPE.clubSupervisor}`,
        component: () => import('./views/club-supervisor.vue'),
        meta: defaultMeta,
      },
      {
        path: INVITE_TYPE.associationOffice,
        name: `ui-invite-${INVITE_TYPE.associationOffice}`,
        component: () => import('./views/association-office.vue'),
        meta: defaultMeta,
      },
      {
        path: INVITE_TYPE.expertAssign,
        name: `ui-invite-${INVITE_TYPE.expertAssign}`,
        component: () => import('./views/expert-assign.vue'),
        meta: defaultMeta,
      },
      {
        path: INVITE_TYPE.transferParticipation,
        name: `ui-invite-${INVITE_TYPE.transferParticipation}`,
        component: () => import('./views/transfer-participation.vue'),
        meta: defaultMeta,
      },
    ],
  },
];
